var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"baseModalBox flex-column-center"},[_c('div',{staticClass:"modalContent"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }